<template>
    <!-- 对话框 -->
    <el-dialog :visible.sync="show" :before-close="closeDialog" width="70%" append-to-body>

        <!-- 基本信息表单 -->
        <div class="form-box">


            <el-form ref="form" label-width="80px" style="overflow-y: auto; height: 65vh;">

                <div style="display: flex;">


                    <el-form-item label="优惠券名称:" label-width='100px'>

                        <el-input v-model="search_data_children.name" style="width: 150px;margin-right: 5px;"
                                  @keyup.enter.native="searchcouponModeLists"></el-input>
                        <el-button @click="searchcouponModeLists">搜索</el-button>

                    </el-form-item>

                </div>


                <!-- 表格 -->
                <el-table :data="tableData" style="width: 100%" height="50vh"  @selection-change="handleSelectionChange" ref="multipleTable">


                    <el-table-column type="selection" width="55" align="center" prop="coupon_mode_code"></el-table-column>



                    <el-table-column prop="name" label="优惠券名称">
                    </el-table-column>

                    <el-table-column prop="quantity" label="剩余数量">
                    </el-table-column>




                    <el-table-column label="添加数量" width="100">
                        <template slot-scope="scope">
                            <div style="display: flex;">

                                <el-input v-model="numLists[scope.row.index].num"></el-input>

                            </div>

                        </template>
                    </el-table-column>


                </el-table>


<!--                <el-pagination class="pagination" layout="prev, pager, next" :total="result_data.count"-->
<!--                               :page-size="search_data_children.limit" @current-change="handleCurrentChange"-->
<!--                               :current-page="search_data_children.page"/>-->


            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex;justify-content: center">
                <el-button type="primary" v-if="loading" icon="el-icon-loading"></el-button>
                <el-button @click="sendSubmit" type="primary" v-else>保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

    </el-dialog>
</template>

<script>
    var _this;
    import bus from '@/components/common/bus.js';
    export default {
        props: {
            'isShow': Boolean,
        },

        watch: {

            isShow(newData, oldData) {

                _this.show = true;



            },

        },
        data() {
            return {
                show: false,

                loading: false,

                tableData: [],

                send_data: [],

                numLists: [],

                result_data:[],

                //翻页数据
                search_data_children: {
                    page: 1,
                    limit: 500,
                    name: '',
                    status:'1'
                },


            };
        },
        created() {

            _this = this;
            // 接收http.js文件传来的通知
            bus.$on("btnStatus", (msg) => {
                this.loading = msg;
            });

        },
        methods: {
            //页码变化
            handleCurrentChange(val) {
                // console.log(val);

                _this.search_data_children.page = val;


                //初始化列表
                _this.couponModeLists();

            },
            searchcouponModeLists(){
              _this.search_data_children.page = 1;
              _this.couponModeLists();
            },
            // 获取列表数据
            couponModeLists() {


                    _this.$post(
                        '/coupon/couponModeLists',
                        _this.search_data_children
                    )
                        .then(res => {

                            _this.tableData = res.data;

                            _this.result_data = res;
                            for (var i = 0; i < res.data.length; i++) {

                                _this.tableData[i].index = i;

                                _this.numLists.push({
                                    num: '0',
                                    name: _this.tableData[i].name,
                                    code: _this.tableData[i].coupon_mode_code,
                                    quantity:_this.tableData[i].quantity,
                                    end_time:_this.tableData[i].end_time
                                });


                            }

                        }).catch((err) => {

                    });



            },

            sendSubmit() {



                let synchronization_data = [];

                // 遍历send_data数组
                for (var i = 0; i < _this.send_data.length; i++) {

                    // 遍历numLists数组
                    for (var j = 0; j < _this.numLists.length; j++) {

                        // numLists数组中存在被选中的code
                        if (_this.send_data[i] == _this.numLists[j].code) {
                            console.log(_this.numLists[j]);
                            synchronization_data.push({
                                name:_this.numLists[j].name,
                                coupon_mode_code: _this.numLists[j].code,
                                num: _this.numLists[j].num,
                                quantity:_this.numLists[j].quantity,
                                end_time:_this.numLists[j].end_time
                            });



                        }
                    }
                }


                console.log(synchronization_data);

                _this.$emit('onSubmit', synchronization_data)

                _this.closeDialog();

            },

            // 表格选中事件
            handleSelectionChange(val) {


                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].coupon_mode_code);

                    for (var j = 0; j < _this.numLists.length; j++) {

                        // 选中项数量变为1
                        if (val[i].coupon_mode_code == _this.numLists[j].code) {

                            if(_this.numLists[j].num == '0'){
                                _this.numLists[j].num = '1';
                            }
                        }
                    }

                }


                _this.send_data = datalist;



            },

            // 关闭方法
            closeDialog() {

                _this.show = false;



                _this.search_data_children = {
                    page: 1,
                    limit: 500,
                    name: ''
                };

                _this.tableData = [];
                _this.send_data = [];
                _this.numLists = [];


            }


        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
